import { Vue, Component } from "vue-property-decorator";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { TranslationsTypes } from "@/data/enums/translations";

// Types
import { IBrand } from "@/models/brands";

@Component
export default class TranslationsMixins extends Vue {
  // Data
  public translationsTypes = TranslationsTypes;

  // Methods
  public openTranslateModal(props: {
    brandId: IBrand["id"];
    fieldLabel: string;
    fieldName: string;
    fieldType: string;
    objectId: string;
    objectTypeCode: TranslationsTypes;
  }) {
    if (!this.canTranslate) return;
    this.$store.dispatch(
      `data/${DataModules.TRANSLATIONS}/openTranslationsModal`,
      { props }
    );
  }

  public get canTranslate() {
    return (
      this.$userCan("create_object_translation") &&
      this.$userCan("get_object_translation") &&
      this.$userCan("list_object_translations")
    );
  }
}
